import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const [login, setLogin] = useState(JSON.parse(localStorage.getItem("currentPharmacyPOS")));
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    setAuthenticated(JSON.parse(localStorage.getItem("authenticated")));
    localStorage.setItem("authenticated", authenticated);
  }, []);
  return login || authenticated ? <Outlet /> : <Navigate exact to={`${process.env.PUBLIC_URL}/login`} />;
  // return <Outlet />;
};

export default PrivateRoute;
// import React from "react";
// import { Navigate, Outlet } from "react-router-dom";

// const PrivateRoute = ({ isLoggedIn }) => {
//   return isLoggedIn ? <Outlet /> : <Navigate to={`${process.env.PUBLIC_URL}/login`} />;
// };

// export default PrivateRoute;
